module.exports = __webpack_public_path__ + "img/coach.95d370d6.svg";